import InsuranceForm from './InsuranceForm';

export default InsuranceForm;



// WEBPACK FOOTER //
// ./src/views/components/InsuranceForm/index.js